AudioContext := window.AudioContext or (window as any).webkitAudioContext

/**
* A default audio context to use for live audio processing throughout the app.
*/
context := new AudioContext
  sampleRate: 48000

export default context
